import React, { useContext } from "react";
import { UserContext } from "../context/UserContext";
import IUser from "../images/IUser.svg"; 

function AvatarImage() {
  const { user } = useContext(UserContext);

  return (
    <div>
      {user?.avatarImg === " " || !user?.avatarImg ? (
        <img src={IUser} className="icon" />
      ) : (
        <img src={user?.avatarImg} alt="User Avatar" className="avatar" />
      )}
    </div>
  );
}

export default AvatarImage;